<template>
  <div class="t-c">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  国学-->
    <div class="item" v-show="status === 5">
      <div :class="['title', status === 5 ? 'animated fadeInUp' : '']">
        <div class="big">国学</div>
        <div class="small">传道授业，斯文在兹</div>
      </div>
      <div :class="['con', status === 5 ? 'animated fadeInUp' : '']">
        心田花开国学拥有优质师资，依托专业教研团队，选取古代经典，横跨经史子集，囊括诗词古文等各类优秀传统文化。旨在让孩子学会读书、学会解书、学会用书——读之有趣，解之有味，学之有用。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"]
};
</script>
<style lang="less">
.t-c {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/t-c.png) center no-repeat;
  position: relative;
  background-size: cover;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
